import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 8px;
`;

export const LabelWrapper = styled.div<{ $iconSize: number }>`
  position: relative;
  width: ${({ $iconSize }) => $iconSize + 18}px;
  height: 16px;
`;

export const LabelText = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
`;

export const StyledTitle = styled.span`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const StyledDescription = styled.span`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StepAndConnectorWrapper = styled.div<{ $iconSize: number }>`
  display: flex;
  align-items: center;
  height: ${({ $iconSize }) => `${$iconSize + 18}px`};
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
